import Link from 'next/link';
import type { ComponentPropsWithoutRef } from 'react';

const EXTERNAL_APPS: string[] = [];

type AnchorProps = Omit<ComponentPropsWithoutRef<'a'>, 'href'> & {
  href: string;
};

type NextLinkProps = ComponentPropsWithoutRef<typeof Link>;

type CustomNavLinkProps = NextLinkProps | AnchorProps;

export const CustomNavLink = ({ href, ...props }: CustomNavLinkProps) => {
  const isExternal = typeof href === 'string' && EXTERNAL_APPS.includes(href);

  if (isExternal) {
    return <a href={href} {...props} />;
  }

  return <Link href={href} {...props} />;
};
